/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as SwitchDefault } from './switch-default.story';
export { default as SwitchIndeterminate } from './switch-indeterminate.story';
export { default as SwitchControlled } from './switch-controlled.story';
export { default as SwitchDisabled } from './switch-disabled.story';
export { default as SwitchHasLabelBefore } from './switch-has-label-before.story';
export { default as SwitchNoLabel } from './switch-no-label.story';
export { default as SwitchFull } from './switch-full.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import SwitchControlledSrcRaw from './switch-controlled.story?raw';
import SwitchDefaultSrcRaw from './switch-default.story?raw';
import SwitchDisabledSrcRaw from './switch-disabled.story?raw';
import SwitchFullSrcRaw from './switch-full.story?raw';
import SwitchHasLabelBeforeSrcRaw from './switch-has-label-before.story?raw';
import SwitchIndeterminateSrcRaw from './switch-indeterminate.story?raw';
import SwitchNoLabelSrcRaw from './switch-no-label.story?raw';

export const SwitchDefaultSrc = removeLicenseHeader(SwitchDefaultSrcRaw);
export const SwitchIndeterminateSrc = removeLicenseHeader(
  SwitchIndeterminateSrcRaw,
);
export const SwitchControlledSrc = removeLicenseHeader(SwitchControlledSrcRaw);
export const SwitchDisabledSrc = removeLicenseHeader(SwitchDisabledSrcRaw);
export const SwitchHasLabelBeforeSrc = removeLicenseHeader(
  SwitchHasLabelBeforeSrcRaw,
);
export const SwitchNoLabelSrc = removeLicenseHeader(SwitchNoLabelSrcRaw);
export const SwitchFullSrc = removeLicenseHeader(SwitchFullSrcRaw);
